<ng-container *ngComponentOutlet="workspaceComponent"></ng-container>
